<template>
  <div class="container bg-white print-list-table">
    <v-btn class="btn-return mb-2" @click="$router.go(-1)">
      <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
    </v-btn>
    <v-btn class="mb-2 btn-print float-right" @click="handlePrint"
      ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
    >
    <b-overlay :show="loading" opacity="0.99">
      <table
        class="bg-white table-important"
        v-for="resident in residents"
        :key="resident.id"
      >
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <div style="page-break-after: always !important">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="row">
                      <div
                        class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 check-text-center text-center pt-0 pb-0"
                      >
                        <img
                          v-if="resident.rest_home_logo_url"
                          class="rest_home_logo_url"
                          :src="resident.rest_home_logo_url"
                        />
                        <div v-if="!resident.rest_home_logo_url" class="ml-1">
                          <strong class="text-uppercase check-text-center">{{
                            resident.rest_home_name
                          }}</strong>
                        </div>
                      </div>
                      <div
                        class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 d-flex align-items-center pt-0 pb-0"
                      >
                        <img
                          v-if="resident.photo_url"
                          class="resident_photo_url"
                          :src="resident.photo_url"
                        />
                        <img
                          v-if="!resident.photo_url"
                          class="resident_photo_url"
                          :src="require('../assets/user.png')"
                        />
                        <ResidentDataPrintDefault :resident_id="resident.id" />
                      </div>
                      <div
                        class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 check-text-right pt-0 pb-0"
                      >
                        <img class="logo" :src="logo" />
                      </div>
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center pt-0 pb-0 show-on-print"
                      >
                        <h1
                          v-if="type == 1"
                          class="title-pages check-text-center"
                        >
                          ESTOQUE ATUAL E PRODUTOS QUE PRECISA COMPRAR
                        </h1>
                        <h1
                          v-if="type == 2"
                          class="title-pages check-text-center"
                        >
                          PRODUTOS QUE PRECISA COMPRAR
                        </h1>
                        <h1
                          v-if="type == 3"
                          class="title-pages check-text-center"
                        >
                          ESTOQUE ATUAL DE PRODUTOS
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="content">
                <table class="table table-sm tabela-igual">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th v-if="[1, 3].includes(type)">Estoque atual</th>
                      <th v-if="[1, 2].includes(type)">Precisa comprar</th>
                      <th v-if="[1, 2].includes(type)">Termina em</th>
                      <th v-if="[1, 2].includes(type)">Observação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="resident_list_item in resident.resident_list_items"
                      :key="resident_list_item.id"
                    >
                      <td>
                        <span v-if="resident_list_item.product_id">{{
                          resident_list_item.product_name
                        }}</span>
                        <span v-if="resident_list_item.medicine_id">{{
                          resident_list_item.medicine_name
                        }}</span>
                      </td>
                      <td v-if="[1, 3].includes(type)">
                        {{ resident_list_item.current_stock }}
                        <span v-if="resident_list_item.product_id">
                          {{
                            resident_list_item.product_unit_of_measurement_abbreviation
                          }}
                        </span>
                        <span v-if="resident_list_item.medicine_id">
                          {{
                            resident_list_item.medicine_unit_of_measurement_abbreviation
                          }}
                        </span>
                      </td>
                      <td v-if="[1, 2].includes(type)">
                        <div v-if="resident_list_item.missing_stock > 0">
                          {{ resident_list_item.missing_stock }}
                          <span v-if="resident_list_item.product_id">
                            {{
                              resident_list_item.product_unit_of_measurement_abbreviation
                            }}
                          </span>
                          <span v-if="resident_list_item.medicine_id">
                            {{
                              resident_list_item.medicine_unit_of_measurement_abbreviation
                            }}
                          </span>
                        </div>
                      </td>
                      <td v-if="[1, 2].includes(type)">
                        <div
                          v-if="
                            resident_list_item.missing_stock > 0 &&
                            resident_list_item.calculation == 1
                          "
                        >
                          {{ resident_list_item.date }}
                        </div>
                      </td>
                      <td v-if="[1, 2].includes(type)">
                        {{ resident_list_item.note }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="footer"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <ErrorsMessages class="mt-2" :errors="errors" />
      <v-btn class="mt-2 btn-print float-right" @click="handlePrint"
        ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
      >
    </b-overlay>
  </div>
</template>

<script>
import ResidentDataPrintDefault from "../components/resident/ResidentDataPrintDefault";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import api from "../services/api";

import routes from "../routes";

import { formatDate } from "../lib/format";

import { userData } from "../lib/functions";

import { getAge } from "../lib/getAgeByDate";

import moment from "moment";

export default {
  name: "Recipe",

  components: {
    ResidentDataPrintDefault,
    ErrorsMessages,
  },

  data() {
    return {
      logo: null,

      type: null,

      resident_id: null,

      residents: [],

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    formatDate,
    userData,
    getAge,

    async retrieve() {
      const { logo } = userData();

      this.logo = logo;

      let { id, type } = routes.currentRoute.params;

      let { resident_id } = routes.currentRoute.query;

      this.id = id;
      this.type = type;
      this.resident_id = resident_id;

      await this.get();
    },

    async get() {
      try {
        this.loading = true;

        let { id, type, resident_id } = this;

        const params = { id, type, resident_id };

        const response = await api.get("/rest-home/list-table", { params });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.residents = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint() {
      window.print();
    },
  },
};
</script>

<style scoped>
.tabela-igual {
  width: 100% !important;
}

.tabela-igual tr th,
.tabela-igual tr td {
  width: 20% !important;
}

.tabela-igual thead tr th {
  background-color: #33495e !important;
  color: #fff !important;
}

.print-list-table .footer {
  display: block !important;
}

.print-list-table .footer {
  height: 200px;
}

.print-list-table table,
.print-list-table td,
.print-list-table th,
.print-list-table tfoot {
  width: 100% !important;
  cursor: auto !important;
}

.print-list-table .table-important {
  width: 100% !important;
  cursor: auto !important;
}

.print-list-table .logo {
  width: 100%;
  height: 50px;
  object-fit: contain;
}

.print-list-table .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.print-list-table .resident_photo_url {
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

@media print {
  @page {
    size: 0;
  }

  .print-list-table {
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
    box-sizing: border-box !important;
  }

  .print-list-table .table-important {
    page-break-before: always !important;
    page-break-inside: avoid !important;
  }

  .print-list-table .footer {
    position: fixed;
    bottom: 0;
    /* left: 0;
    right: 0; */
    width: 92% !important;
    max-width: 100% !important;
  }

  .print-list-table .content {
    page-break-before: always !important;
  }

  .print-list-table .page-break-inside-avoid {
    page-break-inside: avoid !important;
  }

  .print-list-table button {
    display: none;
  }

  .print-list-table .table-important {
    margin: 10px !important;
  }
}
</style>